<template>
  <div class="bottom">
    <div class="center-content">
      <div class="left">
        <img src="@/assets/img/logo.png" alt="">
        <div>
          <h4>四川省久辉电力设备有限公司</h4>
          <span>Sichuan Jiuhui Power Equipment Co., Ltd</span>
          <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2022023096号</a>
        </div>
      </div>
      <div class="right">
        <span>电话：13699414765</span>
        <span>邮箱：576546387@qq.com</span>
        <span>地址：成都市高新区天府四街号2栋7层2号</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bottom"
}
</script>

<style lang="scss" scoped>
.bottom {
  width: 100%;
  background-color: #F5F5F5;

  .center-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 50px;
    padding-bottom: 50px;

    .left {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 150px;
        height: 90px;
      }

      div {
        margin-left: 30px;
        display: flex;
        flex-direction: column;

        a{
          margin-top: 10px;
          color: black;
        }
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      justify-content: center;

      span:nth-child(n+2) {
        margin-top: 20px;
      }

    }
  }
}


</style>